import { defineMessages } from 'react-intl';

export default defineMessages({
  changeMarket: { defaultMessage: 'Change market' },
  market: { defaultMessage: 'market' },
});
